import React, { useState } from "react";
import LinkSlider from "../Components/LinkSlider";
// import OurSolutionBanner from "../Components/OurSolutionBanner";
import { motion } from "framer-motion";
import PeopleSafetyExecution from "../Components/PeopleSafetyExecution";
import Faq from "../Components/Faq";
import Contactus from "../Components/Contactus";
import { SubscribeSection } from "../Components/SubscribeSection";
import { useLanguage } from "../Router/LanguageContext";

export default function RenewableEnergy() {
  const [activeTab, setActiveTab] = useState("bio");
  const [videoLoaded, setVideoLoaded] = useState(false);
  const { dictionary } = useLanguage();

  const bioArray = {
    title: dictionary?.bioTitle,
    description: dictionary?.bioDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.bioPoints || [],
  };

  const solarArray = {
    title: dictionary?.solarTitle,
    description: dictionary?.solarDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.solarPoints || [],
  };

  const offgridArray = {
    title: dictionary?.offgridTitle,
    description: dictionary?.offgridDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.offgridPoints || [],
  };

  const efficiencyArray = {
    title: dictionary?.renewableEfficiencyTitle,
    description: dictionary?.renewableEfficiencyDesc,
    keycapabilities: dictionary?.keyCapabilities,
    arrayData: dictionary?.renewableEfficiencyPoints || [],
  };

  return (
    <>
      {/* <OurSolutionBanner
        title="Powering angola's sustainable future"
        description="Innovative renewable energy solutions designed to drive
                sustainability, efficiency, and energy independence across
                Angola."
        button="Request a consultation"
        bgImage="/assets/img/heroBanner.png"
        redirect="/contact-us"
      /> */}

      <div className="heroSectionBgVideoWrapper">
        {!videoLoaded && (
          <img
            src="/assets/img/energyVideoBanner.png"
            alt=""
            className="bgVideo"
          />
        )}
        <video
          className={`bgVideo ${videoLoaded ? "showVideo" : "hideVideo"}`}
          autoPlay
          muted
          loop
          playsInline
          onLoadedData={() => setVideoLoaded(true)}
        >
          <source src="/assets/video/renewable_service.mp4" type="video/mp4" />
        </video>

        <div className="heroSectionContentOuter">
          <div className="container-fluid maxContainerSection">
            <div className="row heroSectionContent">
              <div className="col-md-12 heroLeftSection aboutTextCenter">
                <h2 className="m-0 f-s-48">{dictionary?.renewableHeroTitle}</h2>
                <p className="m-0 f-s-20">{dictionary?.renewableHeroDesc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LinkSlider />

      <div className="integratedCleanSection">
        <div className="container-fluid maxContainerSection commonPadding">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.cleanEnergyTitle}</h2>
              <p className="m-0 f-s-20">{dictionary?.cleanEnergyDesc}</p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 switchIntegratedOuter">
              <div className="switchIntegrated">
                <div
                  className={`switchIntegratedInner ${
                    activeTab === "bio" ? "switchIntegratedInnerActive" : ""
                  }`}
                  onClick={() => setActiveTab("bio")}
                >
                  <p className="m-0 f-s-20">{dictionary?.bioTitle}</p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "solar" ? "switchIntegratedInnerActive" : ""
                  }`}
                  onClick={() => setActiveTab("solar")}
                >
                  <p className="m-0 f-s-20">{dictionary?.solarTitle}</p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "offgrid" ? "switchIntegratedInnerActive" : ""
                  }`}
                  onClick={() => setActiveTab("offgrid")}
                >
                  <p className="m-0 f-s-20">{dictionary?.offgridTitle}</p>
                </div>

                <div
                  className={`switchIntegratedInner ${
                    activeTab === "efficiency"
                      ? "switchIntegratedInnerActive"
                      : ""
                  }`}
                  onClick={() => setActiveTab("efficiency")}
                >
                  <p className="m-0 f-s-20">
                    {dictionary?.renewableEfficiencyTitle}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {activeTab === "bio" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <motion.img
                  src="/assets/img/Bioenergybiofuelsimg.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {bioArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {bioArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {bioArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {bioArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "solar" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <div className="mission-image-wrapper">
                  <motion.img
                    src="/assets/img/Solarphotovoltaic.png"
                    className="mission-img-main img-fluid"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                  />
                  <motion.img
                    src="/assets/img/Solarphotovoltaiceffect.png"
                    className="mission-img-float mission-img-floatSolar"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    viewport={{ once: true }}
                  />
                </div>
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {solarArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {solarArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {solarArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {solarArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "offgrid" && (
            <div className="row tabSectionInner">
              <div className="col-md-6">
                <motion.img
                  src="/assets/img/offgrid.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {offgridArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {offgridArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {offgridArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {offgridArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "efficiency" && (
            <div className="row tabSectionInner">
              <div className="col-md-6 col-values-img">
                <motion.img
                  src="/assets/img/Energyefficiencyre.png"
                  className="img-fluid"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  viewport={{ once: true }}
                />

                {/* <motion.img
                  className="value-img-main"
                  src="/assets/img/Energyefficiencynew.png"
                  alt=""
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                /> */}
                {/* <motion.img
                  className="value-img-left box-img-common-style EnergyefficiencyBottom"
                  src="/assets/img/Energyefficiencysub.png"
                  alt=""
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                /> */}
                {/* <motion.img
                  className="value-img-right box-img-common-style EnergyefficiencyHeadImage"
                  src="/assets/img/Energyefficiencysub.png"
                  alt=""
                  initial={{ opacity: 0, scale: 0.85 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.25, ease: "easeIn" },
                  }}
                  transition={{ duration: 1, ease: "easeInOut" }}
                  viewport={{ once: true }}
                /> */}
              </div>
              <div className="col-md-6 tabSectionInnerRight">
                <motion.h3
                  className="mission-title m-0 f-s-48"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {efficiencyArray.title}
                </motion.h3>
                <motion.p
                  className="mission-text m-0 f-s-20"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  {efficiencyArray?.description}
                </motion.p>

                <motion.h6
                  className="f-s-20 m-0 keyCapabilities"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  {efficiencyArray.keycapabilities}
                </motion.h6>
                <img src="/assets/img/Line.svg" alt="" className="img-fluid" />
                {efficiencyArray?.arrayData?.map((item, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.4, delay: 0.4 + i * 0.15 }}
                    viewport={{ once: true }}
                  >
                    <div className="energysectionpoints f-s-18">
                      <img src="/assets/img/tickIcon.svg" alt="" /> {item}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <PeopleSafetyExecution />
      <div className="section-main-contact-us">
        <div className="container-fluid maxContainerSection commonPadding pb-0">
          <div className="row">
            <div className="col-md-12 whowearehedaersection ourSolutionSectionHeader">
              <h2 className="m-0 f-s-48">{dictionary?.getInTouchTitle}</h2>
              <p className="m-0 f-s-20 ">{dictionary?.getInTouchDesc}</p>
            </div>
          </div>
          <Contactus />
        </div>
      </div>
      <Faq />
      <SubscribeSection />
    </>
  );
}
